export const challengeNavigationMixin = {
  data: () => ({
    awaitingServerResponse: false
  }),
  methods: {
    setCurrentChallengeIndex(gameCode, teamId, index) {
      this.awaitingServerResponse = true

      console.log(`Setting current challenge index to ${index}...`)
      this.$store
        .dispatch('game/updateCurrentChallenge', {
          code: gameCode,
          teamId: teamId,
          challengeIndex: index
        })
        .then(() => {
          this.awaitingServerResponse = false
        })
        .catch(error => {
          //TODO: Handle error
          console.log('Error while updating current challenge index: ', error)

          this.awaitingServerResponse = false
        })
    },
    setProposedChallengeIndex(gameCode, teamId, index) {
      this.awaitingServerResponse = true

      console.log(`Setting proposed challenge index to ${index}...`)
      this.$store
        .dispatch('game/updateProposedChallenge', {
          code: gameCode,
          teamId: teamId,
          challengeIndex: index
        })
        .then(() => {
          this.awaitingServerResponse = false
        })
        .catch(error => {
          //TODO: Handle error
          console.log('Error while updating proposed challenge index: ', error)

          this.awaitingServerResponse = false
        })
    }
  }
}
